import { render, staticRenderFns } from "./ListOfPayments.vue?vue&type=template&id=f5031f3e"
import script from "./ListOfPayments.vue?vue&type=script&lang=js"
export * from "./ListOfPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports